import { useEffect } from 'react';

import { ThemeToggle } from '@/components/ThemeToggle';
import { cn } from '@/lib/utils';

const SUPPORT_MAILTO = 'mailto:codexpokhara@gmail.com'
    + '?subject=TIPA%20Support%20Request';

function Card({ className, children }: { className?: string; children: React.ReactNode }) {
    return (
        <div className={cn('rounded-2xl border border-border bg-card p-6', className)}>
            {children}
        </div>
    );
}

function ContactUs() {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = 'Contact Us | Tipa';
        return () => {
            document.title = previousTitle;
        };
    }, []);

    return (
        <div className="min-h-[100dvh] bg-background text-foreground">
            <header className="sticky top-0 z-10 border-b border-border/60 bg-background/80 backdrop-blur-xl">
                <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-5 md:px-8">
                    <span className="text-[1.05rem] font-bold tracking-tight text-foreground">
                        Tipa
                    </span>
                    <ThemeToggle />
                </div>
            </header>

            <main className="mx-auto max-w-3xl px-5 pb-24 pt-10 md:px-8 md:pt-14">
                <div className="mb-10">
                    <span className="inline-block rounded-full bg-primary/10 px-2.5 py-1 text-xs font-semibold tracking-wide text-primary">
                        TIPA
                    </span>
                    <h1 className="mt-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
                        Contact Us
                    </h1>
                    <p className="mt-3 text-[0.95rem] text-muted-foreground">
                        Have a question or need help with TIPA? Reach out and we&apos;ll get
                        back to you as soon as possible.
                    </p>
                </div>

                <div className="space-y-10">
                    <section>
                        <h2 className="text-xl font-semibold tracking-tight text-foreground">
                            Support
                        </h2>
                        <Card className="mt-4">
                            <p className="text-[0.95rem] leading-relaxed text-muted-foreground">
                                For bug reports, feature requests, or help using the app, email
                                our support team directly.
                            </p>
                            <a
                                href={SUPPORT_MAILTO}
                                className="mt-4 inline-block rounded-lg bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
                            >
                                Email Support
                            </a>
                            <p className="mt-3 text-sm text-muted-foreground">
                                Or reach us directly at
                                {' '}
                                <code className="rounded border border-border bg-muted px-1.5 py-0.5 text-[0.85em]">
                                    codexpokhara@gmail.com
                                </code>
                            </p>
                        </Card>
                    </section>
                </div>

                <footer className="mt-14 border-t border-border/70 pt-6 text-xs text-muted-foreground">
                    See our
                    {' '}
                    <a
                        href="/tipa/privacy-policy"
                        className="text-primary underline-offset-4 hover:underline"
                    >
                        Privacy Policy
                    </a>
                    {' '}
                    or
                    {' '}
                    <a
                        href="/tipa/delete-account"
                        className="text-primary underline-offset-4 hover:underline"
                    >
                        request account deletion
                    </a>
                    .
                </footer>
            </main>
        </div>
    );
}

export default ContactUs;
